if (!customElements.get("custom-video")) {
  class customVideo extends HTMLElement {
    constructor() {
      super();
      this.videoWrapper = this.querySelector('.td-video-wrapper');
      this.video = this.querySelector('video');
      this.playbutton = this.querySelector('.video-play-button');
      this.playing = false;
      this.blockId = this.getAttribute("data-block-id");
      this.autoplay = this.getAttribute("data-autoplay") || false;
    }

    static currentlyPlayingVideo = null;

    connectedCallback() {
      if (this.video && this.playbutton && this.videoWrapper) {
        this.videoWrapper.addEventListener('click', () => this.handleVideoClick());
    
        // Listen for the custom event emitted from swiper-slider.js
        document.addEventListener('swiperSlideChanged', (evt) => {
          if (this.playing) {
            this.playbutton.style.display = "block";
            this.pauseVideo();
          } else if (this.autoplay == 'true' && this.blockId == evt.detail.slide_id) {
            this.playbutton.style.display = "none";
            this.playVideo();
          }
        });
      }
    }

    handleVideoClick() {
      if (customVideo.currentlyPlayingVideo && customVideo.currentlyPlayingVideo !== this) {
        customVideo.currentlyPlayingVideo.pauseVideo();
      }

      if (this.playing) {
        this.playbutton.style.display = "block";
        this.pauseVideo();
      } else {
        this.playbutton.style.display = "none";
        this.playVideo();
      }
    }

    playVideo() {
      this.video.play().catch(e => console.error('Error attempting to play video:', e));
      this.playing = true;
      customVideo.currentlyPlayingVideo = this;
    }

    pauseVideo() {
      this.video.pause();
      this.playing = false;
      customVideo.currentlyPlayingVideo = null;
    }
  }

  customElements.define("custom-video", customVideo);
}
